import api from '@/api'
import Vue from 'vue'

const state = {
  currentUsuario: null,
  usuarios: [],
  usersLogged: [],
  roles: []
}

const getters = {
  currentUsuario: (state) => state.currentUsuario,
  usuariosAll: (state) => state.usuarios,
  roles: state => state.roles,

  isCurrentUsuarioAdmin: (state) => {
    let isAdmin = false
    if (state.currentUsuario) {
      isAdmin = state.currentUsuario.ROL === 'Admin'
    }
    return isAdmin
  },

  usersLogged: (state) => {
    return state.usersLogged.filter(x => x.USUARIO !== state.currentUsuario.USUARIO)
  },

  getUserLoggedInMedioByID: (state) => (idMedioLogged) => {
    let user = state.usersLogged.find(x => x.ID_MEDIO === idMedioLogged)
    return !!user
  },

  getUsuarioByID: (state) => (id) => {
    return id
      ? state.usuarios.find(x => x.ID_USUARIO?.toLowerCase() === id.toLowerCase())
      : null
  }
}

const mutations = {
  SET_CURRENT_USUARIO (state, currentUsuario) {
    state.currentUsuario = currentUsuario
  },

  SET_USERS_LOGGED (state, usersLogged) {
    state.usersLogged = usersLogged
  },
  SOCKET_usersLoggedIn (state, data) {
    let currentUsuario = state.currentUsuario

    if (!currentUsuario.ID_SOCKET) {
      for (let i = 0; i < data.length; i++) {
        if (currentUsuario.USUARIO === data[i].USUARIO) {
          currentUsuario.ID_SOCKET = data[i].ID_SOCKET
          state.currentUsuario = currentUsuario
        }
      }
    }

    state.usersLogged = data
  },

  SET_USUARIOS (state, usuarios) {
    state.usuarios = usuarios
  },
  SET_ROLES (state, roles) {
    state.roles = roles
  },
  SOCKET_addUsuario (state, usuario) {
    state.usuarios.push(usuario)
    this.notify?.('Nuevo usuario', `Se ha añadido el usuario ${usuario.USUARIO}`)
  },
  SOCKET_updateUsuario (state, usuario) {
    const index = state.usuarios.findIndex(x => x.ID_USUARIO?.toLowerCase() === usuario.ID_USUARIO?.toLowerCase())
    if (index !== -1) {
      Vue.set(state.usuarios, index, { ...usuario })
      this.notify?.('Usuario actualizado', `Se ha actualizado el usuario ${usuario.USUARIO}`)
    }
  },
  SOCKET_deleteUsuario (state, id) {
    const index = state.usuarios.findIndex(x => x.ID_USUARIO?.toLowerCase() === id?.toLowerCase())
    if (index !== -1) {
      const usuarioEliminado = state.usuarios[index]
      state.usuarios.splice(index, 1)
      this.notify?.('Usuario eliminado', `Se ha eliminado el usuario ${usuarioEliminado.USUARIO}`)
    }
  }
}

const actions = {
  userLoggedIn ({ state }) {
    this._vm.$socket.client.emit('loggedIn', state.currentUsuario)
  },

  setCurrentUsuario ({ commit }, currentUsuario) {
    commit('SET_CURRENT_USUARIO', currentUsuario)
  },

  async fetchUsuarios ({ commit }) {
    try {
      const res = await api.usuario.getUsuario()
      commit('SET_USUARIOS', res.data)
    } catch (err) {
      console.error('[store.usuario] Error al obtener usuarios:', err)
      throw err
    }
  },

  async fetchRoles ({ commit }) {
    try {
      const res = await api.usuario.getRoles()
      commit('SET_ROLES', res.data)
    } catch (err) {
      console.error('[store.usuario] Error al obtener roles:', err)
      throw err
    }
  },

  async createUsuario ({ commit, dispatch }, usuario) {
    try {
      const res = await api.usuario.addUsuario(usuario)
      commit('SOCKET_addUsuario', res.data)
      return res
    } catch (err) {
      console.error('[store.usuario] Error al añadir usuario:', err)
      throw err
    }
  },

  async updateUsuario ({ commit }, usuario) {
    try {
      if (!usuario.ID_USUARIO) {
        console.error('[updateUsuario] FALTA ID_USUARIO en:', usuario)
        throw new Error('Falta ID_USUARIO para actualizar')
      }

      const res = await api.usuario.updateUsuario(usuario)
      commit('SOCKET_updateUsuario', res.data)
      return res
    } catch (err) {
      console.error('[store.usuario] Error al actualizar usuario:', err)
      throw err
    }
  },

  async deleteUsuario ({ commit }, idUsuario) {
    try {
      await api.usuario.deleteUsuario(idUsuario)
      commit('SOCKET_deleteUsuario', idUsuario)
    } catch (err) {
      console.error('[store.usuario] Error al eliminar usuario:', err)
      throw err
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
